
export default function sendReport () {

    //send report for stats script

        let simulateur = "CSS aide-sociale.fr";
        let url = window.location.href;
        let host = document.referrer;
        let simulation = new Date();

        let jour = String(simulation.getDate()).padStart(2, '0');
        let mois = String(simulation.getMonth() + 1).padStart(2, '0'); // Les mois sont indexés à partir de 0
        let annee = simulation.getFullYear();
        let heures = String(simulation.getHours()).padStart(2, '0');
        let minutes = String(simulation.getMinutes()).padStart(2, '0');
        let secondes = String(simulation.getSeconds()).padStart(2, '0');

        simulation = `${jour}/${mois}/${annee} ${heures}:${minutes}:${secondes}`;


        let data = {
            "simulateur" : simulateur,
            "url" : url,
            "host" : host,
            "simulation" : simulation
        };

        const request = {
            method: 'POST',
            mode:'no-cors',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin' : '*',
            },

            body:JSON.stringify(data)
        };

        const requestURI = "https://www.aide-sante.com/simulateur/simulogs.php";
        fetch(requestURI ,request)
        .then((res)=> {
            //return res.json();
        });
    
    return null;
}